import React from 'react';
import { CoverTile, StatusPill, gameTypeLabel } from './activityAdminShared';

export default function ActivityList({ activities, tags, gameTagId, gameTypes, selectedId, onSelect }) {
  const tagById = new Map(tags.map((t) => [t.id, t]));

  if (!activities.length) {
    return (
      <div className="aaList aaList--empty">
        <p>No activities match.</p>
      </div>
    );
  }

  return (
    <ul className="aaList">
      {activities.map((a) => {
        const tagged = a.tag_ids.includes(gameTagId);
        const otherTags = a.tag_ids.filter((id) => id !== gameTagId).map((id) => tagById.get(id)).filter(Boolean);
        return (
          <li key={a.id}>
            <button
              type="button"
              className={`aaRow${a.id === selectedId ? ' aaRow--selected' : ''}`}
              onClick={() => onSelect(a.id)}
              aria-current={a.id === selectedId ? 'true' : undefined}
            >
              <CoverTile activity={a} size={48} />
              <span className="aaRow__main">
                <span className="aaRow__title">{a.title || <em>Untitled</em>}</span>
                <span className="aaRow__meta">
                  <StatusPill status={a.status} />
                  {a.game_type && <span className="aaBadge aaBadge--game">🎮 {gameTypeLabel(gameTypes, a.game_type)}</span>}
                  {!a.game_type && tagged && <span className="aaBadge aaBadge--warn">🎮 No game type</span>}
                  {a.picture_count > 0 && <span className="aaBadge">🖼️ {a.picture_count}</span>}
                  {a.app_only && <span className="aaBadge">📱 App only</span>}
                  {otherTags.map((t) => (
                    <span key={t.id} className="aaTagDot" style={{ background: t.color }} title={t.name} />
                  ))}
                </span>
              </span>
              <span className="aaRow__id">#{a.id}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
